// extracted by mini-css-extract-plugin
module.exports = {"h1":"Header_h1__6irVf","h2":"Header_h2__3o7aS","h3":"Header_h3__aXu-S"};